/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-10-29 17:09:58
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-10-29 19:06:52
 * @Content:
 */

import React, { FC, memo, useCallback } from "react";
import { IGoalCarouselDatum } from "./interface";
import { map } from "lodash";
import GoalCarouselItem from "./GoalCarouselItem";
import "./index.css";

const PREFIX = "GoalCarousel";

interface IProps {
  goals: IGoalCarouselDatum[];
  selectedGoalNum: number;
  onClick: (index: number) => void;
}

const GoalCarousel: FC<IProps> = memo(({ goals, selectedGoalNum, onClick }) => {
  return (
    <div className={PREFIX}>
      <div className={`${PREFIX}-content`}>
        {map(goals, (goal, index) => {
          return (
            <GoalCarouselItem
              isSelected={selectedGoalNum == index}
              index={index}
              onClick={onClick}
              state={goal.state}
            />
          );
        })}
      </div>
    </div>
  );
});

export default GoalCarousel;
